import { CircleAlert, RotateCcw } from "lucide-react";
import type { ReactNode } from "react";
import { useSiteCopy } from "../i18n/useSiteCopy.ts";
import { useDocumentTitle } from "../routing.ts";
import { Button } from "../ui/Button.tsx";

const RouteError = (): ReactNode => {
  const copy = useSiteCopy().routeError;
  useDocumentTitle(copy.title);
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center gap-4 px-4 py-20 text-center">
      <CircleAlert aria-hidden="true" className="size-12 text-danger" />
      <h1 className="text-4xl font-semibold">{copy.title}</h1>
      <p className="text-muted-foreground">{copy.body}</p>
      {/* A full reload fetches the current release, also when an old chunk is gone after a deploy. */}
      <Button className="mt-2" onClick={() => window.location.reload()}>
        <RotateCcw aria-hidden="true" className="size-4" />
        {copy.reload}
      </Button>
    </div>
  );
};

/**
 * `errorElement` for data routers: a page whose code failed to load (a chunk removed
 * by a deploy), or whose loader or render threw. Needs <CourseKitProvider> above the
 * router. `standalone` when it replaces the whole layout (the root route), so the
 * page still has its <main> landmark.
 */
export const RouteErrorPage = ({ standalone = false }: { standalone?: boolean }): ReactNode =>
  standalone ? (
    <main id="main" className="min-h-dvh bg-background">
      <RouteError />
    </main>
  ) : (
    <RouteError />
  );
